import inmersys_rotate from "./Inmersys_Logo.png";

export const gifs = {
	inmersys_rotate,
};
